import type { PropertyType } from '@salescore/core'
import type dayjs from 'dayjs'

// PropertyType ごとの、項目が持つ値の形式。セルの表示・変更の比較・連携先への書き込みがこの形式を前提にしている
const DATE_PROPERTY_FORMAT = 'YYYY-MM-DD'
const DATETIME_PROPERTY_FORMAT = 'YYYY-MM-DDTHH:mm:ss'

/**
 * date系の値で PropertyType に対応する形式の値に変換する
 * @param propertyType 項目の型
 * @param date 整形する date
 * @returns 項目が持つ値。date / datetime 以外の PropertyType は undefined
 */
export const formatDatePropertyValue = ({
  propertyType,
  date,
}: {
  propertyType: PropertyType
  date: dayjs.Dayjs
}): string | undefined => {
  switch (propertyType) {
    case 'date': {
      return date.format(DATE_PROPERTY_FORMAT)
    }
    case 'datetime': {
      return date.format(DATETIME_PROPERTY_FORMAT)
    }
    default: {
      return undefined
    }
  }
}
